module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dash-header"
  }, [_c('div', {
    staticClass: "dash-header-top"
  }, [_c('div', {
    staticClass: "dash-header-left"
  }, [_c('h1', {
    staticClass: "dash-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "dash-sub"
  }, [_vm._v(_vm._s(_vm.subText))])]), _vm._v(" "), _c('div', {
    staticClass: "dash-meta"
  }, _vm._l((_vm.metaRows), function(item) {
    return _c('div', {
      key: item.label,
      staticClass: "dash-meta-row"
    }, [_c('span', {
      staticClass: "dash-meta-label"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('span', {
      staticClass: "dash-meta-value"
    }, [_vm._v(_vm._s(item.value))])])
  }), 0)]), _vm._v(" "), (_vm.chips && _vm.chips.length) ? _c('div', {
    staticClass: "dash-chips"
  }, _vm._l((_vm.chips), function(chip) {
    return _c('span', {
      key: chip.label,
      staticClass: "dash-chip"
    }, [_c('i', {
      staticClass: "chip-icon"
    }), _vm._v(" "), _c('span', {
      staticClass: "chip-label"
    }, [_vm._v(_vm._s(chip.label))]), _vm._v(" "), _c('span', {
      staticClass: "chip-value"
    }, [_vm._v(_vm._s(chip.value))])])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea629156","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tchImpact/parts/ImpactHeader.vue
// module id = 1997
// module chunks = 8